export function required(messageKey?: string) {
  return (value: string | number | boolean) => {
    return !value && (messageKey || 'RequiredError');
  };
}
